import { TableHeader } from "@/models/TableHeader";

export const tppClaimsHeader: TableHeader[] = [
  {
    text: "Location Code",
    value: "facility_location_code",
    width: "8rem"
  },
  {
    text: "First Name",
    value: "reporter_first_name"
  },
  {
    text: "Last Name",
    value: "reporter_last_name"
  },
  {
    text: "Claim #",
    value: "claim_number"
  },
  {
    text: "Incident Date",
    value: "incident_date"
  },
  {
    text: "TPP Filed Date",
    value: "created_at"
  },
  {
    text: "Loss Type",
    value: "loss_type_name"
  },
  {
    text: "Status",
    value: "status"
  },
  {
    text: "Actions",
    sortable: false,
    value: "actions"
  }
];
